import { render, staticRenderFns } from "./CartOffers.vue?vue&type=template&id=4cf27ef3&scoped=true&"
import script from "./CartOffers.vue?vue&type=script&lang=js&"
export * from "./CartOffers.vue?vue&type=script&lang=js&"
import style0 from "./CartOffers.vue?vue&type=style&index=0&id=4cf27ef3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cf27ef3",
  null
  
)

export default component.exports